<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <mau-environment-banner [environment]="environment"></mau-environment-banner>
</ion-app>
